import React, { Component,Suspense } from "react";
import * as ReactDOM from "react-dom";
import edit from "../image/icons/edit.png"
import plus from "../image/icons/plus.png"
import $ from 'jquery'
import speciality1 from '../image/orthopod/speciality1.png'
import speciality2 from '../image/orthopod/speciality2.png'
const folderName = window.sessionStorage.getItem("homeName");

export default class MiddleBanner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      centreData: [],
      parentName:'',
      SubList:[],
      sectionName:'Centre'
    };
  }

  componentDidMount() {
    const Centre = JSON.parse(window.sessionStorage.getItem("Centre"));
    // console.log(Centre)
    if (Centre) {
      this.setState({ centreData: Centre});
      this.setState({ SubList: Centre[0].sectionList });
      this.setState({ parentName: Centre[0].parentName })
    } else {
     // window.location.reload(false);
    }
  }

  addClick (sid,pId,cId,psubTitle,cTitile,cdescri,childUrl,childImg,sOrder) {
    if ($("#CentreParentId").val() !== "") {
      pId = $("#CentreParentId").val();
  }
  if (childImg) {
      var splitImg = childImg.split("theme/")
      childImg = splitImg[1];
  }


    const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage  
              sessionId={sid} 
              parentId={pId}
              childId={cId}
              patentTitle={this.state.parentName}
              parentSubTitle={psubTitle}
              childTitle={cTitile}
              childDesri={cdescri}
              sectionName={this.state.sectionName}
              childUrl={childUrl}
              childImg={childImg}
              sortSubOrder={sOrder}
            />
          </section>
        </Suspense>
      </div>,
      document.getElementById("centrepopUpBlock")
    );
    $("#centrepopUpBlock").addClass('editActive');
  }

     render(){

       return (
      
        <div class="mentalMiddleBanner dashContent">   
        {this.props.changeTheme === "theme" && (
       <h4 class="mainHead text-center">{'Our Services'}</h4>
       )}              
          <div class="container" id="Centre">
          {this.props.changeTheme === "theme" && (
          <div className="editIconSec" id="Centre">
           <span className="editIcon editAddIcon" title="Add"
            onClick={() => this.addClick("14","","","","","","","","")}>
             <img src={plus} alt="Add"/>
             </span>
           </div>
             )}
           <div className="cmsContentDiv" id="centrepopUpBlock"></div>        
            <input type="hidden" id="centreSectionId" value="14"/>
            {this.state.centreData.map((data) => {
              return (
                <div>  
         <input type="hidden" id="CentreParentId" value={data.parentId} />
              {data.sectionList.length != "0" && (
              <div>
              {data.sectionList.map((ban, index) => {
              return (
            <div class="treatmentList">
                {this.props.changeTheme === "theme" && (
                <div className="editIconSec editIconSecTop">
                 <span className="editIcon editAddIcon" title="Edit" 
                 onClick={() => this.addClick
                (data.sectionId,
                data.parentId,
                ban.childId,
                data.parentSubTitle,
                ban.childName,
                ban.childDescription,
                ban.childUrl,
                ban.childImage,
                ban.homeAdsSubSortOrder
               )}>
                <img src={edit} alt="logo"/></span>
              
            </div>
            )}
              <a href={ban.childUrl} >
             <div class="treatmentImage">
                    <img src={ban.childImage} alt="banner image" />
              </div>
              {ban.childName!="@" ? (
              <div class="treatmentContent">
                  <span>{ban.childName}</span>
              </div>
                ) : ''}
            </a>
             {/* <img src={ban.childImage} alt="" class="mb-3" /> */}
            </div>         
            //  ))}
            // </div>
            );
        })}
        </div>
        )}
      </div>
          );
        })}
          </div>
        </div>
       )
     }
   }
